import React, { useContext } from 'react'
import { NavLink, withRouter } from 'react-router-dom'
import { AuthContext } from '../context/AuthContext'

export const MainPage = () => {
    const auth = useContext(AuthContext)
    const style = { marginTop: "10%" }
    return (
        <div className="container">
        <div className="row">
            <NavLink style={{ marginTop: "7.5%" }} className="waves-effect waves-light btn-large blue col s12" to={'/search'}>Поиск по базе</NavLink>
            <NavLink style={{ marginTop: "7.5%" }} className="waves-effect waves-light btn-large blue col s12" to={'/cards'}>База</NavLink>
            <NavLink style={{ marginTop: "7.5%" }} className="waves-effect waves-light btn-large blue col s12" to={'/add'}>Добавить клиента</NavLink>
            <NavLink style={{ marginTop: "7.5%" }} className="waves-effect waves-light btn-large blue col s12" to={'/costs'}>Счета</NavLink>
        </div>
        </div>
    )
}